import { css, styled } from 'styled-components';
import { device } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px 16px;
  padding: 32px;
  padding-bottom: 16px;
  background-color: ${({ theme }) => theme.neutral_200};
  border-radius: 16px;

  .title {
    color: ${({ theme }) => theme.primary_500};
  }

  .container {
    display: grid;
  }

  @media (max-width: ${device.tablet}px) {
    padding-bottom: 32px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px 20px;
  padding: 0 18px;
  overflow: auto;
  padding-bottom: 12px;

  @media (max-width: ${device.tablet}px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    padding-top: 8px;
  }
`;

export const BarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  max-width: 24px;
  min-width: 24px;
  height: 100%;
  min-height: 200px;

  @media (max-width: ${device.tablet}px) {
    flex-direction: row-reverse;
    max-height: 24px;
    min-height: 24px;
    width: 100%;
    max-width: unset;
    min-width: unset;
    min-height: unset;

    .bar-wrapper-text {
      width: 40px;
    }
  }
`;

export const BarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  border-radius: 10px;
  background-color: ${({ theme }) => theme.neutral_300};
  height: 100%;
  justify-content: flex-end;

  @media (max-width: ${device.tablet}px) {
    flex-direction: row-reverse;
    width: 100%;
    height: unset;
  }
`;

export const Bar = styled.div<{
  $approved?: boolean;
  $size: number;
  $isZero: boolean;
}>`
  position: relative;
  width: 8px;
  min-height: 8px;
  border-radius: 40px;
  background-color: ${({ theme }) => theme.danger_500};
  color: ${({ theme }) => theme.danger_500};

  @media (max-width: ${device.tablet}px) {
    min-width: 8px;
    height: 8px;
  }

  ${({ $approved }) =>
    $approved &&
    css`
      background-color: ${({ theme }) => theme.success_500};
      color: ${({ theme }) => theme.success_500};
    `}

  ${({ $isZero }) =>
    $isZero &&
    css`
      background-color: ${({ theme }) => theme.neutral_300};
      color: ${({ theme }) => theme.neutral_300};
    `}

  ${({ $size }) => css`
    height: ${$size}%;

    @media (max-width: ${device.tablet}px) {
      width: ${$size}%;
    }
  `}
`;

export const TextWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transform: rotate(270deg);
  width: 10px;
  height: 10px;
  top: 0px;
  left: -12px;

  .bar-text {
    line-height: 0;
    text-align: end;
  }

  @media (max-width: ${device.tablet}px) {
    transform: rotate(0deg);
    top: -12px;
    left: unset;
    right: 0px;
  }
`;
